import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LocalStorageService {
    setData(key: string, value: any): void {
        localStorage.setItem(key, JSON.stringify(value));
    }

    getData(key: string) {
        const storedValue = localStorage.getItem(key);
        return storedValue ? JSON.parse(storedValue) : null;
    }
}